import React from "react";
import { Link } from "@/components/common/Link";
import { ArrowRight } from "lucide-react";
import { EcommerceProductsProvider, useEcommerceProducts, AddToCartButton } from "@/integrations/wordpress/WordPressEcommerceProductsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
function FeaturedGearConsumer() {
  const {
    products,
    loading,
    error
  } = useEcommerceProducts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {[...Array(4)].map((_, i) => <div key={i} data-index={i} className="aspect-[3/4] w-full animate-pulse rounded-xl bg-muted/20" />)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Unable to load mission gear at this time.</p>
      </div>;
  }
  if (!products || products.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>No mission gear found.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {products.map((product, i) => <div key={product.id} data-index={i} className="group relative flex flex-col">
          <Card className="h-full overflow-hidden border-border/10 bg-card text-card-foreground transition-colors duration-300 hover:border-primary/30">
            <CardContent className="p-0">
              {}
              <div className="relative aspect-[4/5] w-full overflow-hidden bg-muted/10">
                {product.featured_image_url ? <img src={product.featured_image_url} alt={product.title} className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" /> : <div className="flex h-full w-full items-center justify-center bg-secondary text-muted-foreground">
                    <span className="text-sm">No Image</span>
                  </div>}
                
                {}
                <div className="absolute inset-x-4 bottom-4 translate-y-4 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                  <AddToCartButton productId={product.id} variant="default" className="w-full shadow-lg" buttonClassName="w-full bg-primary text-white hover:bg-primary/90 font-bold uppercase tracking-wide text-xs py-6" text="Quick Add" showQuantity={false} />
                </div>
              </div>

              {}
              <div className="flex flex-col gap-2 p-5">
                <Link to={product.link} className="group-hover:underline">
                  <h3 className="line-clamp-1 text-lg font-bold text-foreground">
                    {product.title}
                  </h3>
                </Link>
                
                <div className="flex items-center justify-between">
                  <span className="text-lg font-bold text-primary">
                    ${product.price.toFixed(2)}
                  </span>
                  {product.customFields?.stock_status === 'outofstock' && <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
                      Sold Out
                    </span>}
                </div>
              </div>
            </CardContent>
          </Card>
        </div>)}
    </div>;
}
export default function FeaturedMissionGear() {
  const wp_query_params = {
    per_page: 4,
    orderby: "date",
    order: "desc",
    status: "publish"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="featured-mission-gear" className="dark bg-background text-foreground py-20 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        {}
        <div className="mb-12 flex flex-col items-center text-center">
          <h2 className="text-3xl font-bold uppercase tracking-tight text-white md:text-4xl lg:text-5xl">
            Wear the Mission
          </h2>
          <div className="mt-4 h-1 w-24 bg-primary"></div>
          <p className="mt-4 max-w-2xl text-muted-foreground">
            Every product represents strength, resilience, and unity. When you wear Paniolo Trails, you stand with veterans and first responders.
          </p>
        </div>

        {}
        <EcommerceProductsProvider wp_query={{
        per_page: 4,
        orderby: "date",
        order: "desc",
        status: ["publish"]
      }} postType="product" className="w-full">
          <FeaturedGearConsumer />
        </EcommerceProductsProvider>

        {}
        <div className="mt-16 flex justify-center">
          <Link to="#">
            <Button variant="outline" size="lg" className="border-2 border-border bg-transparent px-8 py-6 text-base font-bold uppercase tracking-widest text-foreground transition-all hover:border-primary hover:bg-primary hover:text-white">
              View All Apparel
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}